// Global route utilities
let globalDispatch: any = null;
let globalState: any = null;
let isNavigatingFromBackButton = false;

// Initialize global dispatch and state references
export const initializeRouteUtils = (dispatch: any, state: any) => {
  globalDispatch = dispatch;
  globalState = state;
};

// Set flag when navigating from back button
export const setBackButtonNavigation = (isFromBackButton: boolean) => {
  isNavigatingFromBackButton = isFromBackButton;

  // Auto-reset flag after a short delay
  if (isFromBackButton) {
    setTimeout(() => {
      isNavigatingFromBackButton = false;
    }, 100);
  }
};

// Check if current navigation is from back button
export const isFromBackButton = () => {
  return isNavigatingFromBackButton;
};

// Set previous route globally (with back button check)
export const setGlobalPrevRoute = (path: string) => {
  if (!globalDispatch || !globalState) {
    return;
  }

  // Skip saving prevRoute if navigation is from back button
  if (isNavigatingFromBackButton) {
    return;
  }

  globalDispatch({
    type: "prevRoute",
    payload: {
      ...globalState,
      prevRoute: path
    }
  });
};

// Get current previous route
export const getGlobalPrevRoute = (): string | null => {
  if (!globalState) {
    return null;
  }
  return globalState.prevRoute || null;
};

export const getGlobalState = (): any => {
  return globalState;
};
